import { createAction, createAsyncAction } from "typesafe-actions";

import type { BenchmarkType } from "app/pages/benchmark-tracker/hooks/types";

export const setSelectedBenchmark = createAction(
    "@@benchmark-tracker/benchmark-entity/set-selected-benchmark-entity",
)<BenchmarkType>();

export const getBenchmark = createAsyncAction(
    "@@benchmark-tracker/benchmark-entity/getBenchmark/request",
    "@@benchmark-tracker/benchmark-entity/getBenchmark/success",
    "@@benchmark-tracker/benchmark-entity/getBenchmark/failure",
)<void, BenchmarkType, void>();
